import styled from 'styled-components';

export const FormWrapper = styled('div')`
  padding: 30px 30px 0;
  font-family: 'General Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;

  .uploadDuration {
    color: var(--color-text-muted);
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;

    span {
      font-size: 12px;
      font-weight: 500;
      line-height: 18px;
    }
  }

  .uploadDescription {
    color: var(--color-text-subtle);
  }

  .multipleFilesHandling {
    .description {
      padding: 10px 0 0;
      color: var(--color-text-subtle);
    }
  }

  .repositoryBlockDescription {
    padding: 10px 0 0;
    color: var(--color-text-subtle);
  }

  ul {
    margin: 0;
    color: var(--color-text-subtle);
    padding: 0 0 0 18px;
  }

  .errorMessage {
    font-weight: 500;
    font-size: 10px;
    line-height: 100%;
    color: #ff2f2f;
    height: 12px;
  }
`;
